export class Module {
	public constructor(el: HTMLElement) {
		this.#setViewportEntryAnimation(el);
	}

	/**
	 * detect when the element enters or leaves the viewport and trigger an animation by adding/removing classes
	 */
	#setViewportEntryAnimation(el: HTMLElement): void {
		// Add a class to identify that the script has identified the element. Allows CSS to avoid setting animation
		// start states on elements if the script fails.
		el.classList.add("viewport-entry-animate--registered");

		// If element is anywhere above the bottom part of the viewport, set it to animate-active.
		// - used when page reloads and element is scrolled off the top of the screen, not triggering the intersection
		const bounds = el.getBoundingClientRect();
		if (bounds.top < window.innerHeight) {
			el.classList.add("viewport-entry-animate--active");
		}

		// Register an intersection observer to identify when the element comes ~30% into the viewport, and flag with a
		// class to start the animation. Remove the class to reset the animation when the element leaves the viewport.
		new IntersectionObserver(
			entries => {
				const intersection = entries[0];
				if (intersection === undefined) {
					return;
				}

				// start the animation when ~10% becomes visible in the viewport
				if (
					intersection.isIntersecting
					&& intersection.intersectionRatio >= 0.1
				) {
					el.classList.add("viewport-entry-animate--active");
					return;
				}

				// reset animation when content scrolls off the bottom of the viewport (scrolling up) so the animation
				// can be triggered again.
				// - not intersecting with viewport AND origin isn't above the viewport
				if (
					!intersection.isIntersecting
					&& intersection.boundingClientRect.y > 0
				) {
					el.classList.remove("viewport-entry-animate--active");
					return;
				}
			},
			{
				rootMargin: "150px 0px 0px 0px",
				threshold: [0, 0.1],
			},
		).observe(el);
	}
}
